import { RootState } from 'store';

export const getBookingsState = (state: RootState) => state.bookings;
